export interface Service {
  name: string
  description: string
}

export const services: Service[] = [
  {
    name: 'House Washing',
    description:
      'Full exterior soft wash for siding, trim, and gutters — algae, dirt, and cobwebs rinsed away without damage.',
  },
  {
    name: 'Roof Cleaning & Moss Removal',
    description:
      'Low-pressure treatment that lifts moss, lichen, and black streaks off shingles so the roof lasts longer.',
  },
  {
    name: 'Window Cleaning',
    description:
      'Interior and exterior glass, screens, and tracks — pure-water pole work for streak-free upper stories.',
  },
  {
    name: 'Driveways & Walkways',
    description:
      'Surface cleaning for concrete, pavers, and stone. Oil spots, mildew, and years of grime, gone.',
  },
  {
    name: 'Decks, Patios & Fences',
    description:
      'Careful pressure washing that brings composite, wood, and stone back to their original color.',
  },
  {
    name: 'Commercial Buildings',
    description:
      'Shops, barns, and multi-family properties washed on a schedule that stays out of your way.',
  },
]
